export type PopupLogLevel = 'debug' | 'info' | 'warn' | 'error';

const LOG_PREFIX = '[Teo Widget POPUP]';
const STORAGE_KEY = 'teo_widget_popup_debug';

/** Embed / bootstrap fallback. localStorage always wins when set. */
let embedEnabled: boolean | null = null;

function readLocalStorageFlag(): boolean | null {
  if (typeof window === 'undefined') return null;
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === '1' || stored === 'true') return true;
    if (stored === '0' || stored === 'false') return false;
  } catch {
    // ignore
  }
  return null;
}

function readScriptFlag(): boolean {
  if (typeof document === 'undefined') return false;
  const script = document.querySelector<HTMLScriptElement>(
    'script[data-teo-initialized][data-popup-debug], script[data-slug][data-popup-debug], script[data-mock][data-popup-debug]',
  );
  return (
    script?.dataset.popupDebug === 'true' || script?.dataset.popupDebug === ''
  );
}

function readDebugFlag(): boolean {
  const stored = readLocalStorageFlag();
  if (stored !== null) return stored;
  if (embedEnabled !== null) return embedEnabled;
  return readScriptFlag();
}

/**
 * Set fallback from embed bootstrap (`data-popup-debug` / env).
 * Does **not** write localStorage — that is the live override:
 * `localStorage.setItem('teo_widget_popup_debug', '1')`
 */
export function setPopupDebugEnabled(enabled: boolean): void {
  embedEnabled = enabled;
}

export function isPopupDebugEnabled(): boolean {
  return readDebugFlag();
}

export function logPopup(
  scope: string,
  message: string,
  data?: unknown,
  level: PopupLogLevel = 'info',
): void {
  if (!readDebugFlag()) return;

  const label = `${LOG_PREFIX} [${scope}] ${message}`;
  const payload = data === undefined ? undefined : [label, data];

  switch (level) {
    case 'debug':
      if (payload) console.debug(...payload);
      else console.debug(label);
      break;
    case 'warn':
      if (payload) console.warn(...payload);
      else console.warn(label);
      break;
    case 'error':
      if (payload) console.error(...payload);
      else console.error(label);
      break;
    default:
      if (payload) console.info(...payload);
      else console.info(label);
  }
}
